import { getThemedEnv } from './utils/theme';
const env = getThemedEnv(typeof window !== 'undefined' && process.env.REACT_APP_USE_GLOBAL_ENV === 'true' ? {
  ...process.env,
  ...JSON.parse(window.__APP_ENV_JSON)
} // eslint-disable-line no-underscore-dangle
: process.env);
export default env;
//# sourceMappingURL=env.js.map